<template>
    <div class="my-set-ui-form">
        <!-- 早晚子时 -->
        <div class="my-set-ui-section">
            <div class="my-set-ui-title"><span>早晚子时设置</span></div>
            <div class="my-set-ui-s-title-2">
                <p>子时设置不影响已有数据，每个八字可单独设置是否区分早晚子时</p>
            </div>
            <div class="my-set-ui-s-item">
                <span class="my-set-ui-s-title">分早晚子时</span><span class="my-set-ui-s-title-2">24点为新一天的开始</span>
                <van-switch class="collate-form-switch" v-model="choosedZWZ" @change="changeZWZ" size="22px" active-color="#0d9700" inactive-color="#eee" />
            </div>
            <div class="my-set-ui-s-item">
                <span class="my-set-ui-s-title">不分早晚子时</span><span class="my-set-ui-s-title-2">23点为新一天的开始</span>
                <van-switch class="collate-form-switch" v-model="choosedNZWZ" @change="changeNZWZ" size="22px" active-color="#0d9700" inactive-color="#eee" />
            </div>
        </div>
        <!-- 四柱流运格式 -->
        <div class="my-set-ui-b-section my-set-ui-b-section2">
            <div class="my-set-ui-title"><span>四柱流运格式</span></div>
            <my-set-fate-panel></my-set-fate-panel>
            <!-- 四柱、流运 -->
            <div class="my-set-ui-list dsp-flex">
                <div class="my-set-ui-item dsp-flex" v-bind:class="{'selected': parseInt(settingConfigData.sizhuGeShi) == 0}" @click="clickSetSiZhu(0)">
                    <div class="text sizhu"><p>四</p><p>柱</p></div>
                    <div class="text liuyun"><p>流</p><p>运</p></div>
                </div>
                <div class="my-set-ui-item dsp-flex" v-bind:class="{'selected': parseInt(settingConfigData.sizhuGeShi) == 1}" @click="clickSetSiZhu(1)">
                    <div class="text liuyun"><p>流</p><p>运</p></div>
                    <div class="text sizhu"><p>四</p><p>柱</p></div>
                </div>
            </div>
            <!-- 年月日时 -->
            <div class="my-set-ui-list dsp-flex">
                <div class="my-set-ui-item dsp-flex" v-bind:class="{'selected': parseInt(settingConfigData.nianyueRishi) == 0}" @click="clickSetNyrs(0)">
                    <div class="text all">年-月-日-时</div>
                </div>
                <div class="my-set-ui-item dsp-flex" v-bind:class="{'selected': parseInt(settingConfigData.nianyueRishi) == 1}" @click="clickSetNyrs(1)">
                    <div class="text all">时-日-月-年</div>
                </div>
            </div>
        </div>
        <!-- 干支、十神、藏干、五行、纳音 -->
        <div class="my-set-ui-hide">
            <span class="my-set-ui-hide-item" v-for="(typeText, index) in showTypes" @click="clickShowType(index)">
                <i class="iconfont " v-bind:class="{'icon-unselected': index!=curShowType,'icon-selected': index==curShowType}"></i>{{typeText}}
            </span>
        </div>
        <!-- 其他开关设置:早晚子时 -->
        <div class="my-set-ui-b-section">
            <div class="my-set-ui-s-item">
                <span class="my-set-ui-s-title">五行五色显示</span>
                <van-switch class="collate-form-switch" v-model="choosedColor" @change="changeColor" size="22px" active-color="#0d9700" inactive-color="#eee" />
            </div>
        </div>
        <!-- 其他开关设置:运盘流年显示数量 -->
        <div class="my-set-ui-section my-set-ui-section-other">
            <div class="my-set-ui-title">运盘流年显示数量</div>
            <div class="my-set-ui-list dsp-flex">
                <div class="my-set-ui-item no-pad dsp-flex" v-bind:class="{'selected': parseInt(settingConfigData.liuYunCount) == 1}" @click="clickSetCount(1)">
                    <div class="note-text"><p>流</p><p>年</p></div>
                    <div class="note-border b-10">
                        <span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span><span></span>
                    </div>
                </div>
                <div class="my-set-ui-item no-pad dsp-flex" v-bind:class="{'selected': parseInt(settingConfigData.liuYunCount) == 0}" @click="clickSetCount(0)">
                    <div class="note-text"><p>流</p><p>年</p></div>
                    <div class="note-border b-5">
                        <span></span><span></span><span></span><span></span><span></span>
                    </div>
                </div>
            </div>
        </div>
        <!-- 真太阳时设置 -->
        <div class="my-set-ui-section">
            <div class="my-set-ui-title"><span>真太阳时自动设置</span></div>
            <div class="my-set-ui-s-item">
                <span class="my-set-ui-s-title">使用真太阳时</span><span class="my-set-ui-s-title-2">（即地方时间）</span>
                <van-switch class="collate-form-switch" v-model="choosedRT" @change="changeRT" size="22px" active-color="#0d9700" inactive-color="#eee" />
            </div>
            <div class="my-set-ui-s-item">
                <span class="my-set-ui-s-title">使用北京时间</span><span class="my-set-ui-s-title-2">（忽略地方时间）</span>
                <van-switch class="collate-form-switch" v-model="choosedNRT" @change="changeNRT" size="22px" active-color="#0d9700" inactive-color="#eee" />
            </div>
        </div>
        <!-- 重置按钮 -->
        <div class="my-set-ui-btn" @click="clickResetAll">重置命盘显示设置</div>
    </div>
</template>

<script>
import MySetFatePanel from '../../layouts/panel/MySetFatePanel.vue'
import { CONST_SHISHEN_SHOW_TYPES } from '../../modules/data/base/consts'
export default {
    name: 'MySetForm',
    components: { MySetFatePanel },
    computed: {
        curShowType() {
            return this.$store.state.setting.curShowType;
        },
        settingConfigData() {
            return this.$store.state.setting.settingConfigData;
        }
    },
    data() {
        return {
            showTypes: CONST_SHISHEN_SHOW_TYPES,
            choosedZWZ: false, choosedNZWZ: false,
            choosedRT: false, choosedNRT: false,
            choosedColor: false,
        }
    },
    mounted() {
        setTimeout(() => {
            this.initData();
        }, 20);
    },
    methods: {
        initData() {
            this.choosedZWZ = parseInt(this.settingConfigData.zaoWanZiShi) == 1 ? true : false;
            this.choosedNZWZ = parseInt(this.settingConfigData.zaoWanZiShi) == 0 ? true : false;
            this.choosedColor = parseInt(this.settingConfigData.showColor) == 1 ? true : false;
            this.choosedRT = parseInt(this.settingConfigData.rt) == 0 ? true : false;
            this.choosedNRT = parseInt(this.settingConfigData.rt) == 1 ? true : false;
        },
        clickShowType(index) {
            console.error('clickShowType------', index)
            this.$store.state.setting.curShowType = index;
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    showShiShenGZ: index
                }
            })
        },
        clickSetSiZhu(value) {
            // 设置四柱流年格式
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    sizhuGeShi: value
                }
            });
        },
        clickSetNyrs(value) {
            // 设置年月日时格式
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    nianyueRishi: value
                }
            });
        },
        changeZWZ(value) {
            console.error('changeZWZ-------', value)
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    zaoWanZiShi: value ? 1 : 0
                }
            });
            this.choosedNZWZ = value ? false : true;
        },
        changeNZWZ(value) {
            console.error('changeNZWZ-------', value)
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    zaoWanZiShi: value ? 0 : 1
                }
            });
            this.choosedZWZ = value ? false : true;
        },
        changeRT(value) {
            console.error('changeRT-------', value)
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    rt: value ? 0 : 1
                }
            });
            this.choosedNRT = value ? false : true;
        },
        changeNRT(value) {
            console.error('changeNRT-------', value)
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    rt: value ? 1 : 0
                }
            });
            this.choosedRT = value ? false : true;
        },
        changeColor(value) {
            console.error('changeColor------', value)
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    showColor: value ? 1 : 0
                }
            });
        },
        clickSetCount(count) {
            // 设置四柱流年格式
            this.$store.state.detail.fatefortune.showTable = count == 1 ? 10 : 5;
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    liuYunCount: count
                }
            });
        },
        clickResetAll() {
            console.error('clickResetAll------')
            var me = this;
            this.$store.dispatch('setting/updateSettingData', {
                params: {
                    showShiShenGZ: 1,
                    liuYunCount: 0,
                    zaoWanZiShi: 1,
                    nianKongWang: 1,
                    riKongWang: 1,
                    sizhuGeShi: 0,
                    showColor: 1,
                    nianyueRishi: 0,
                    rt: 0,
                },
                cb: function() {
                    me.initData();
                }
            });
        }
    },
    
}
</script>